<template>
  <b-modal
    id="folder-modal"
    cancel-title="Annulla"
    cancel-variant="outline-secondary"
    centered
    ok-title="Crea"
    title="Aggiungi Cartella"
    @ok="add"
  >
    <b-form>
      <b-form-group>
        <label for="name">Nome:</label>
        <b-form-input
          id="name"
          v-model="label"
          placeholder="Nome Cartella"
          type="text"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import objectsRepository from '@/api/objectsRepository'
import { mapGetters } from 'vuex'

export default {
  name: 'Modal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      label: '',
    }
  },
  computed: {
    ...mapGetters({
      currentFolder: 'myStore/currentFolder',
    }),
  },
  methods: {
    async add() {
      this.$emit('loading', true)
      const { data } = await objectsRepository.createDir({
        label: this.label,
        father_id: this.currentFolder,
      })
      if (data.code) {
        this.$emit('added')
      } else {
        console.log('error add folder')
      }
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style>
[dir="ltr"] .modal-header .close {
  margin: -0.5rem -0.6rem -0.5rem auto;
}
</style>
